module.exports = __webpack_public_path__ + "static/fonts/b01b8a8a-cb45-4c4e-b2bb-e5b8853e6fe6.cc06d64.woff2";